import type { AnswerData, QuestionTreeItem } from '/business/shared/functions/types';

export default function normalisePath({
  answer = null,
  question = null,
}: {
  answer?: AnswerData | null;
  question?: QuestionTreeItem | null;
}): string {
  let path: string | string[] | false = false;
  if (answer) {
    path = answer.type || false;
  } else if (question) {
    if (question.apiKey) {
      return question.apiKey;
    }
    path = question.path || false;
  }
  if (!path) {
    throw new Error('No path provided');
  }
  return (Array.isArray(path) ? path.join('-') : path).replace(/^.*questions[-/]*/gim, '');
}
